import React,{useRef,useState,useEffect} from 'react';
import {DataTable,QuotationInfoCard} from '../../Components'
import { useNavigate } from 'react-router-dom';
import { Controller, set, useForm } from "react-hook-form";

import {NumberFormat,MobileFormat,DateThaiFormat,DateFormat,DateThai,GetRole} from '../../Utils/Function';

import { createRoot } from 'react-dom/client';
import CustomerCreate from '../../Components/Customer/CustomerCreate';
import{CustomerInfoCard} from '../../Components/Customer';
import Swal from 'sweetalert2';
import API from '../../API';
import "react-datepicker/dist/react-datepicker.css";
import '../../Assets/CSS/TALFC.css';

const PageCardList =()=> {
    const RedirectTo = useNavigate()
    const { register, getValues, setValue } = useForm();

    const ref = useRef();
    const _CustomerInfoCard = useRef();
    const _CustomerCreate = useRef();
    const [GroupList,setGroupList] = useState([]);

    useEffect(() => {
        (async () => {
        })();

        return ()=>{ }
    }, []);

    const _configs = {
        "order": [[0, "desc"]],
        pageLength: 25,
        orderMulti: true
    }
    const _ajax  = {
        'url': '/Card/List',
        'method': 'POST',
        'caches': false,
        'global': false,
        'data': function (d) {
        }
    };

    const _Buttons = (d,r) => (
        <div className='btn-group btn-group-sm'>
        </div>
    )
    const _column = [
        { data: "CardNo", name: "CardNo", autoWidth: true },
        { data: "CardMode", name: "CardMode", autoWidth: true,render(data){
            switch(data){
                case 0:return 'ยกเลิก';
                case 1:return 'ว่าง';
                case 2:return 'ใช้งาน';
                case 3:return 'เปลี่ยน';
                default : return 'ไม่ระบุ';
            }
        } },
        { data: "MemberCode", name: "MemberCode", autoWidth: true },
        { data: "Name", name: "Name", autoWidth: true },
        {data: "Updated", name: "Updated", autoWidth: true,render(data){
            return DateThaiFormat(data,true);
        }},
        {
            data: "CardNo", name: "CardNo", autoWidth: true,
            render: (data) => { return ''; },
            createdCell: (td, cellData,rowData) => createRoot(td).render(_Buttons(cellData,rowData))
        }
    ]
    const _ColumnDefs = [
    ]
    
    const _UpdateTable =()=>{
        ref.current?.load();
    }

    return (
        <>
        <React.Fragment>
            <div className='container-fluid'>
                <div className='row mt-4'>
                    <div className='col-lg-12'>
                    <div className='card'>
                            <div className='card-header'>
                                <h3 className='card-title'>จัดการข้อมูลบัตร</h3>
                            </div>
                            <div className='card-body' style={{'minHeight':'300px'}}>
                                <div className='row'>
                                    <div className="col-lg-12 table-responsive">
                                        <table id="MemberTableView" className='table w-100' role='grid'>
                                            <thead>
                                                <tr>
                                                    <th className="text-center textcenter">รหัสบัตร</th>
                                                    <th className="text-center textcenter">สถานะบัตร</th>
                                                    <th className="text-center textcenter">รหัสเลขประจำตัว</th>
                                                    <th className="text-center textcenter">ชื่อ</th>
                                                    <th className="text-center textcenter">วันที่แก้ไข</th>
                                                    <th className="text-center no-sort"></th>
                                                </tr>
                                            </thead>
                                            <DataTable TableID={"MemberTableView"} Column={_column} Configs={_configs} ref={ref} ajax={_ajax} ColumnDefs={_ColumnDefs} />
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <CustomerCreate ref={_CustomerCreate} />
            <CustomerInfoCard ref={_CustomerInfoCard} />
        </React.Fragment>
        </>
    )
}

export default React.memo(PageCardList)
